<!---------------------------->
<!-- Provider Portal Menu-->
<!---------------------------->

<ng-container *ngIf="isProviderPorterRole">
  <div>
    <mat-toolbar class="toolbar">
      <mat-toolbar-row>
        <ng-container [ngTemplateOutlet]="logoAndSettingsIcon" [ngTemplateOutletContext]="{ url: '/provider/dashboard' }"></ng-container>
        <ng-container *ngIf="hasProviderPortalAccess">
          <ng-container *ngTemplateOutlet="supportIconTpl; context: {$implicit: '/provider/support'}"></ng-container>
        </ng-container>
        <ng-container [ngTemplateOutlet]="accountAndLogoutIconTpl"></ng-container>
      </mat-toolbar-row>
    </mat-toolbar>
  </div>

  <div *ngIf="hasProviderPortalAccess else permissionDenied" class="border-bottom m-l-25 m-r-25">
    <button mat-button [routerLink]="'/claim-management'" [queryParams]="{tab: TabClaimsQueryParams.Claims}">Claims</button>
    <button mat-button (click)="onClickOpenMemberLookup()">Members</button>
  </div>
</ng-container>

<!---------------------------->
<!-- Normal Portal Menu-->
<!---------------------------->
<ng-container *ngIf="!isProviderPorterRole && !isOnboardingAdminPortalRole && !isBrokerPortalRole">
  <div>
    <mat-toolbar class="toolbar">
      <mat-toolbar-row>
        <ng-container [ngTemplateOutlet]="logoAndSettingsIcon" [ngTemplateOutletContext]="{ url: '/home' }"></ng-container>
        <ng-container [ngTemplateOutlet]="verificationDDN"></ng-container>
        <ng-container *ngIf="hasNormalPortalAccess">
          <mat-icon color="primary" class="toolbar-icon" #notificationTooltip="matTooltip" matTooltip="Notifications"
                    aria-label="mail" [matMenuTriggerFor]="notificationMenu"
                    matBadge="{{numberOfOpenCases + numberOfOpenTickets}}" matBadgeColor="warn"
                    [matBadgeHidden]="numberOfOpenCases + numberOfOpenTickets === 0">mail
          </mat-icon>
        </ng-container>

        <ng-container *ngIf="hasNormalPortalAccess">
          <ng-container *ngTemplateOutlet="supportIconTpl; context: {$implicit: '/support'}"></ng-container>
        </ng-container>

        <ng-container [ngTemplateOutlet]="accountAndLogoutIconTpl"></ng-container>

        <mat-menu #notificationMenu="matMenu">
          <span [matTooltip]="!showCases ? DisplayStrings.CASE_MANAGEMENT_FEATURE_DISABLED : ''">
            <button [disabled]="!showCases" [routerLink]="'/claim-management'" [queryParams]="{tab: TabClaimsQueryParams.Cases, status: caseStatus.Open, manager: loggedInUserName }" mat-menu-item>{{openCasesDisplayText()}}</button>
          </span>
          <button [routerLink]="'/issue-ticket-management'" mat-menu-item>{{openTicketsDisplayText()}}</button>
        </mat-menu>

      </mat-toolbar-row>
    </mat-toolbar>
  </div>
  <div *ngIf="hasNormalPortalAccess; else permissionDenied" class="border-bottom m-l-25 m-r-25">
    <button mat-button [routerLink]="'/reporting'">Reporting</button>

    <ng-container *ngIf="showCases || showPayments; else claimsLink">
      <button mat-button [matMenuTriggerFor]="claimMenu">
        Claims
        <mat-icon>arrow_drop_down</mat-icon>
      </button>
      <mat-menu #claimMenu="matMenu">
        <button [disabled]="!showCases" [routerLink]="'/claim-management'" [queryParams]="{tab: TabClaimsQueryParams.Cases}" mat-menu-item>{{TabLabel.Cases}}</button>
        <ng-container [ngTemplateOutlet]="claimTab"></ng-container>
        <button [disabled]="!showPayments" [routerLink]="'/claim-management'" [queryParams]="{tab: TabClaimsQueryParams.Payments}" mat-menu-item>{{TabLabel.Payments}}</button>
      </mat-menu>
    </ng-container>
    <ng-template #claimsLink>
      <button mat-button [routerLink]="'/claim-management'" [queryParams]="{tab: TabClaimsQueryParams.Claims}">Claims</button>
    </ng-template>
    <button mat-button [matMenuTriggerFor]="administrationMenu">Enterprise<mat-icon>arrow_drop_down</mat-icon></button>
    <mat-menu #administrationMenu="matMenu">
      <button [routerLink]="'/enterprise-management'" [queryParams]="{tab: TabEnterpriseQueryParams.Provider}" mat-menu-item>Providers</button>
      <button [routerLink]="'/enterprise-management'" [queryParams]="{tab: TabEnterpriseQueryParams.ProviderGroup}" mat-menu-item>Provider Groups</button>
      <button [routerLink]="'/enterprise-management'" [queryParams]="{tab: TabEnterpriseQueryParams.ProviderNetwork}" mat-menu-item>Provider Networks</button>
      <button [routerLink]="'/enterprise-management'" [queryParams]="{tab: TabEnterpriseQueryParams.ProviderPriceList}" mat-menu-item>Provider Price List</button>
      <button [routerLink]="'/enterprise-management'" [queryParams]="{tab: TabEnterpriseQueryParams.Person}" mat-menu-item>Persons</button>
      <button [routerLink]="'/enterprise-management'" [queryParams]="{tab: TabEnterpriseQueryParams.Policy}" mat-menu-item>Policies</button>
      <button [routerLink]="'/enterprise-management'" [queryParams]="{tab: TabEnterpriseQueryParams.Applications}" mat-menu-item>Applications</button>
      <button [routerLink]="'/enterprise-management'" [queryParams]="{tab: TabEnterpriseQueryParams.PolicyHolderGroups}" mat-menu-item>PolicyHolder Groups</button>
      <button [routerLink]="'/enterprise-management'" [queryParams]="{tab: TabEnterpriseQueryParams.Brokers}" mat-menu-item>Brokers</button>
      <button [routerLink]="'/enterprise-management'" [queryParams]="{tab: TabEnterpriseQueryParams.Products}" mat-menu-item>Products</button>
      <button [routerLink]="'/enterprise-management'" [queryParams]="{tab: TabEnterpriseQueryParams.Benefits}" mat-menu-item>Benefits</button>
      <button [routerLink]="'/enterprise-management'" [queryParams]="{tab: TabEnterpriseQueryParams.Limits}" mat-menu-item>Limits</button>
      <button [routerLink]="'/enterprise-management'" [queryParams]="{tab: TabEnterpriseQueryParams.ClinicalCoding}" mat-menu-item>Clinical Coding</button>
    </mat-menu>

    <button mat-button [matMenuTriggerFor]="pharmacyMenu">Pharmacy<mat-icon>arrow_drop_down</mat-icon></button>
    <mat-menu #pharmacyMenu="matMenu">
      <button [routerLink]="'/pharmacy-management'" [queryParams]="{tab: TabPharmacyQueryParams.NationalDrugs}" mat-menu-item>National Drugs</button>
      <button [routerLink]="'/pharmacy-management'" [queryParams]="{tab: TabPharmacyQueryParams.ExternalDrugData}" mat-menu-item>External Drug Data</button>
      <button [routerLink]="'/pharmacy-management'" [queryParams]="{tab: TabPharmacyQueryParams.MasterDrugs}" mat-menu-item>Master Drugs</button>
      <button [routerLink]="'/pharmacy-management'" [queryParams]="{tab:  TabPharmacyQueryParams.DrugInteractions}" mat-menu-item>Drug Interactions</button>
      <button [routerLink]="'/pharmacy-management'" [queryParams]="{tab:  TabPharmacyQueryParams.NationalDrugFormularies}" mat-menu-item>National Drug Formularies</button>
      <button [routerLink]="'/pharmacy-management'" [queryParams]="{tab:  TabPharmacyQueryParams.DrugManagementPlans}" mat-menu-item>Drug Management Plans</button>
      <button [routerLink]="'/pharmacy-management'" [queryParams]="{tab:  TabPharmacyQueryParams.Manufacturers}" mat-menu-item>Manufacturers</button>
      <button [routerLink]="'/pharmacy-management'" [queryParams]="{tab:  TabPharmacyQueryParams.Ingredients}" mat-menu-item>Ingredients</button>
      <button [routerLink]="'/pharmacy-management'" [queryParams]="{tab:  TabPharmacyQueryParams.ATCCodes}" mat-menu-item>ATC Codes</button>
    </mat-menu>

    <button mat-button *ngIf="showInbox" [matMenuTriggerFor]="aiAgentsMenu">AI Agents<mat-icon>arrow_drop_down</mat-icon></button>
    <mat-menu #aiAgentsMenu="matMenu">
      <button [routerLink]="'/claim-management/inbox'" mat-menu-item>Ingest Authorisation</button>
    </mat-menu>

    <ng-container *ngTemplateOutlet="rulesEngineMenuTpl; context: {$implicit: '/rules-engine-metadata'}"></ng-container>

    <button mat-button [matMenuTriggerFor]="supportMenu">Other<mat-icon>arrow_drop_down</mat-icon></button>
    <mat-menu #supportMenu="matMenu">
      <button [routerLink]="'/support'" mat-menu-item>Support</button>
      <button [routerLink]="'/issue-ticket-management'" mat-menu-item>Issue Management</button>
      <button [routerLink]="'/user-management'" mat-menu-item>User Management</button>
      <button mat-menu-item [matMenuTriggerFor]="dataCenterMenu">Data Center</button>
      <mat-menu #dataCenterMenu="matMenu">
        <button [routerLink]="'/data-center-management'" [queryParams]="{tab: TabDataCenterQueryParams.MemberData}" mat-menu-item>{{TabDataCenterLabel.MemberData}}</button>
        <button [routerLink]="'/data-center-management'" [queryParams]="{tab: TabDataCenterQueryParams.ExternalData}" mat-menu-item>{{TabDataCenterLabel.ExternalData}}</button>
      </mat-menu>
    </mat-menu>
  </div>

</ng-container>


<!---------------------------->
<!-- onboarding Admin Portal Menu-->
<!---------------------------->

<ng-container *ngIf="isOnboardingAdminPortalRole">
  <div>
    <mat-toolbar class="toolbar">
      <mat-toolbar-row>
        <ng-container [ngTemplateOutlet]="logoAndSettingsIcon" [ngTemplateOutletContext]="{ url: '/onboarding/applications' }"></ng-container>
        <ng-container [ngTemplateOutlet]="verificationDDN"></ng-container>
        <ng-container *ngTemplateOutlet="supportIconTpl; context: {$implicit: '/onboarding/support'}"></ng-container>
        <ng-container [ngTemplateOutlet]="accountAndLogoutIconTpl"></ng-container>
      </mat-toolbar-row>
    </mat-toolbar>
  </div>

  <div class="border-bottom m-l-25 m-r-25">
    <button [routerLink]="'/onboarding/reporting'" mat-button>Reporting</button>
    <button [matMenuTriggerFor]="administrationMenu" mat-button>Enterprise<mat-icon>arrow_drop_down</mat-icon></button>
    <mat-menu #administrationMenu="matMenu">
      <button [routerLink]="'/onboarding/applications'" mat-menu-item>Applications</button>
      <button [routerLink]="'/onboarding/persons'" mat-menu-item>Persons</button>
      <button [routerLink]="'/onboarding/policyholder-groups'" mat-menu-item>PolicyHolder Groups</button>
      <button [routerLink]="'/onboarding/brokers'" mat-menu-item>Brokers</button>
    </mat-menu>

    <ng-container *ngTemplateOutlet="rulesEngineMenuTpl; context: {$implicit: '/onboarding/rules-engine-metadata'}"></ng-container>

    <button [matMenuTriggerFor]="supportMenu" mat-button>Other<mat-icon>arrow_drop_down</mat-icon></button>
    <mat-menu #supportMenu="matMenu">
        <!-- Onboarding is simplified version of Normal portal therefore using same Env flag to hide support icon in case of no access-->
        <ng-container *ngIf="hasNormalPortalAccess">
          <button [routerLink]="'/onboarding/support'" mat-menu-item>Support</button>
        </ng-container>
      <button [routerLink]="'/onboarding/user-management'" mat-menu-item>User Management</button>
    </mat-menu>
  </div>
</ng-container>

<!---------------------------->
<!-- onboarding Broker Portal Menu-->
<!---------------------------->

<ng-container *ngIf="isBrokerPortalRole">
  <greydom-broker-menu *ngIf="hasBrokerPortalAccess else permissionDenied"
    [logoAndSettingsIcon]="logoAndSettingsIcon"
    [supportIconTpl]="supportIconTpl"
    [accountAndLogoutIconTpl]="accountAndLogoutIconTpl">
  </greydom-broker-menu>
</ng-container>

<!---------------------------->
<!-- Member/Bank Id Verification -->
<!---------------------------->

<ng-template #verificationDDN>
  <ng-container *ngIf="hasSearchMemberPermissions">
    <mat-icon color="primary"
              class="toolbar-icon"
              #verificationTooltip="matTooltip"
              matTooltip="Verifications"
              [matMenuTriggerFor]="verificationMenu">
      search
    </mat-icon>
    <mat-menu #verificationMenu="matMenu">
      <button mat-menu-item (click)="onClickOpenMemberLookup()">Member Lookup</button>
      <button mat-menu-item (click)="onClickOpenIdVerification()">ID Verification</button>
      <button mat-menu-item (click)="onClickOpenBankVerification()">Bank Verification</button>
    </mat-menu>
  </ng-container>
</ng-template>

<!---------------------------->
<!-- Logo & Settings Icon Tpl:-->
<!---------------------------->
<ng-template #logoAndSettingsIcon let-url="url">
  <div class="logo-section">
    <div class="flex items-center">
      <a [routerLink]=url>
        <i [class]="showPoweredByOverride ? 'override-main-logo' : theme + '-logo'"></i>
      </a>
      <p *ngIf="environmentName !== prodEnvironmentLabel"
         class="font-small m-l-20 mat-primary-color">{{environmentName}}</p>
    </div>
  </div>

  <span class="flex-auto"></span>

  <ng-container *ngIf="isProviderPorterRole; else normalHeader">
    <ng-container *ngIf="hasProviderPortalAccess">
      <ng-container [ngTemplateOutlet]="settingsMenuIcon"></ng-container>
    </ng-container>
  </ng-container>

  <ng-template #normalHeader>
    <ng-container *ngIf="hasNormalPortalAccess">
      <ng-container [ngTemplateOutlet]="settingsMenuIcon"></ng-container>
    </ng-container>
  </ng-template>

  <ng-template #settingsMenuIcon>
    <mat-icon *ngIf="showSettingsIcon"
              color="primary" class="toolbar-icon" #settingsTooltip="matTooltip" matTooltip="Settings"
              aria-label="mail" [matMenuTriggerFor]="settingsMenu">settings
    </mat-icon>

    <mat-menu #settingsMenu="matMenu">
      <button (click)="refreshEnterpriseCache()" mat-menu-item>Refresh Enterprise Cache</button>
      <button (click)="refreshClaimsCache()" mat-menu-item>Refresh {{TabLabel.Transactions}} Cache</button>
      <button (click)="refreshWorkflowCache()" mat-menu-item>Refresh Workflow Cache</button>
    </mat-menu>
  </ng-template>


</ng-template>

<!---------------------------->
<!-- Claims Tpl:-->
<!---------------------------->

<ng-template #claimTab>
  <button [routerLink]="'/claim-management'" [queryParams]="{tab: TabClaimsQueryParams.Claims}" mat-menu-item>{{TabLabel.Transactions}}</button>
</ng-template>



<!---------------------------->
<!-- Support Page Icons Tpl:-->
<!---------------------------->
<ng-template #supportIconTpl let-routeLink>
  <mat-icon [routerLink]="routeLink" color="primary" class="toolbar-icon" #helpTooltip="matTooltip" matTooltip="Support" aria-label="help">help
  </mat-icon>
</ng-template>

<!---------------------------->
<!-- Account/Logout Icons Tpl:-->
<!---------------------------->
<ng-template #accountAndLogoutIconTpl>
  <mat-icon color="primary" class="toolbar-icon" #accountTooltip="matTooltip" matTooltip="Account"
            aria-label="account" (click)="openAccount()">account_circle
  </mat-icon>
  <mat-icon color="primary" class="toolbar-icon" #signOutTooltip="matTooltip" matTooltip="Sign Out"
            aria-label="sign out" (click)="signOut()">exit_to_app
  </mat-icon>

  <div *ngIf="theme !== Themes.Greydom || showPoweredByOverride" class="powered-by font-extra-small">
    Powered by <a class="mat-primary-color" [href]="greydomSiteURL" target="_blank">
    <i class="greydom-poweredBy-logo">
    </i></a>
  </div>
</ng-template>

<!---------------------------->
<!-- Common Icons Tpl:-->
<!---------------------------->

<ng-template #rulesEngineMenuTpl let-routeLink>
  <button [matMenuTriggerFor]="ruleMenu" mat-button>Rules<mat-icon>arrow_drop_down</mat-icon></button>
  <mat-menu #ruleMenu="matMenu">
    <button (click)="openLinkInNewTab('Rules Author')" mat-menu-item>Rules Author</button>
    <button (click)="openLinkInNewTab('Rules Engine')" mat-menu-item>Rules Engine</button>
    <button [routerLink]="routeLink" mat-menu-item>Rules Engine Metadata</button>
  </mat-menu>
</ng-template>

<!---------------------------->
<!-- Permission Denied Tpl:-->
<!---------------------------->
<ng-template #permissionDenied>
  <app-permission-denied></app-permission-denied>
</ng-template>
